export const contractAddress = '0x35AA8DDfbE233dc1a9FA0900D3A0F36ec033EaD4'


export const chainRPC = "https://damp-flashy-shape.matic-testnet.discover.quiknode.pro/535a357f0e184e3b4189adb3158a3e284328c0c6/"
